// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___3Y6h","errors":"Errors_errors__38PpC"};